//展示管理
import http from '../jslibs/axios/http';

// banner列表
export const getBannerList = data => http.get('/cms/Banner', data);
// 新增banner
export const addBanner = data => http.post('/cms/Banner', data);
//编辑banner
export const updateBanner = data => http.put('/cms/Banner/' + data.uuid, data);
//banner详情
export const getBannerDetail = data => http.get('/cms/Banner/' + data.uuid);
//删除banner
export const deleteBanner = data => http.delete('/cms/Banner/' + data.uuid);
//banner上下架
export const updateBannerVis = data => http.put('/cms/BannerVis/' + data.uuid,data);


//核心技术列表
export const getArtList = data => http.get('/cms/Art', data);
//删除核心技术
export const deleteArt = data => http.delete('/cms/Art/' + data.uuid);
// 添加核心技术
export const addArt = data => http.post('/cms/Art', data);
//编辑核心技术
export const updateArt = data => http.put('/cms/Art/' + data.uuid, data);
//核心技术详情
export const getArtDetail = data => http.get('/cms/Art/' + data.uuid);
//核心技术上下架
export const updateArtVis = data => http.put('/cms/ArtVis/' + data.uuid,data);


//关于我们
export const getABOUT_US = data => http.get('/cms/Config/ABOUT_US', data);
//关于我们
export const setABOUT_US = data => http.put('/cms/Config/ABOUT_US',data);

// 服务据点列表
export const getServiceLocationList = data => http.get('/cms/ServiceLocation', data);
// 新增服务据点
export const addServiceLocation = data => http.post('/cms/ServiceLocation', data);
//编辑服务据点
export const updateServiceLocation = data => http.put('/cms/ServiceLocation/' + data.uuid, data);
//服务据点详情
export const getServiceLocationDetail = data => http.get('/cms/ServiceLocation/' + data.uuid);
//删除服务据点
export const deleteServiceLocation = data => http.delete('/cms/ServiceLocation/' + data.uuid);


// 常见问题列表
export const getProblemList = data => http.get('/cms/Problem', data);
// 新增常见问题
export const addProblem = data => http.post('/cms/Problem', data);
//编辑常见问题
export const updateProblem = data => http.put('/cms/Problem/' + data.uuid, data);
//常见问题详情
export const getProblemDetail = data => http.get('/cms/Problem/' + data.uuid);
//删除常见问题
export const deleteProblem = data => http.delete('/cms/Problem/' + data.uuid);


//关于我们
export const getConfig = data => http.get('/cms/Config/'+data.key, data);
//关于我们
export const setConfig = data => http.put('/cms/Config/'+data.key,data);